import React from 'react'
import './specialSwitch.css'

export default class extends React.Component {
  render() {
    const {
      size,
      leftLabel,
      rightLabel,
      defaultValue,
      onLargeSwitchChange
    } = this.props

    return (
      <div
        className={`special_switch_container ${size ? 'small' : ''}`}
      >
        <div
          className={`switch_left ${defaultValue == 1 ? 'active' : ''}`}
          onClick={() => onLargeSwitchChange && onLargeSwitchChange(1)}
        >
          {!leftLabel ? '用户选择' : leftLabel}
        </div>
        <div
          className={`switch_right ${defaultValue != 1 ? 'active' : ''}`}
          onClick={() => onLargeSwitchChange && onLargeSwitchChange(2)}
        >
          {!rightLabel ? '球房选择' : rightLabel}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/specialSwitch/specialSwitch.js